class ProductStickyAtc extends HTMLElement {
  constructor() {
    super();
    this.stickyBar = this;
    this.scrollTrigger = parseInt(this.dataset.sectionId) || 400;
    this.variantId = this.querySelector('[id^="StickyVariantId"]');
    this.priceEl = this.querySelector('[id^="StickyAtcPrice"]');
  }

  connectedCallback() {
    const triggerPx = this.closest('section')?.previousElementSibling
      ? 400
      : 400;

    window.addEventListener('scroll', () => this.onScroll(), { passive: true });

    document.addEventListener('variant:change', (e) => this.onVariantChange(e));
  }

  onScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY > 400) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  onVariantChange(e) {
    const { variant } = e.detail;
    if (!variant) return;

    if (this.variantId) {
      this.variantId.value = variant.id;
    }

    if (this.priceEl && variant.price) {
      this.priceEl.textContent = this.formatMoney(variant.price);
    }

    const btn = this.querySelector('.product-sticky-atc__button');
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available
        ? (btn.dataset.addLabel || 'Add to Cart')
        : (btn.dataset.soldOutLabel || 'Sold Out');
    }
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-EG', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EGP',
    });
  }
}

customElements.define('product-sticky-atc', ProductStickyAtc);

document.addEventListener('DOMContentLoaded', () => {
  const stickyAtcs = document.querySelectorAll('.product-sticky-atc');
  stickyAtcs.forEach((el) => {
    window.addEventListener('scroll', () => {
      if ((window.scrollY || window.pageYOffset) > 400) {
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
      }
    }, { passive: true });

    const form = el.querySelector('.product-sticky-atc__form');
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          });
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        } catch (err) {
          console.error('Sticky ATC error:', err);
        }
      });
    }
  });
});
